module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile2-page",
    class: _vm.isMobile() === true ? '' : 'foo'
  }, [_c('div', {
    staticClass: "profile2-layout"
  }, [_c('div', {
    staticClass: "profile2-hero"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "profile2-identity"
  }, [_c('p', {
    staticClass: "profile2-eyebrow"
  }, [_vm._v("Profil")]), _vm._v(" "), _c('h1', {
    staticClass: "profile2-name"
  }, [_vm._v(_vm._s(_vm.model.name) + " " + _vm._s(_vm.model.surname))])])]), _vm._v(" "), _c('div', {
    staticClass: "profile2-action",
    on: {
      "click": function($event) {
        return _vm.editProfile()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "profile2-action__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_edit_profile')))])]), _vm._v(" "), _c('div', {
    staticClass: "profile2-action",
    on: {
      "click": function($event) {
        return _vm.resetPassword()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "profile2-action__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_change_password')))])]), _vm._v(" "), _c('div', {
    staticClass: "profile2-panel"
  }, [_c('p', {
    staticClass: "profile2-panel__title"
  }, [_vm._v("Jezik")]), _vm._v(" "), _c('div', {
    staticClass: "profile2-chip-grid"
  }, _vm._l((_vm.languages), function(language) {
    return _c('div', {
      key: language.id,
      class: ['profile2-chip', _vm.selectedLanguageClass(language.id)],
      on: {
        "click": function($event) {
          return _vm.selectLanguage(language.id)
        }
      }
    }, [_c('img', {
      staticClass: "profile-lang-icon",
      attrs: {
        "src": _vm.getIconById(language.id),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "language-item-text"
    }, [_vm._v(_vm._s(language.name))])])
  }), 0)]), _vm._v(" "), (_vm.allCustomCategories.length > 0) ? _c('div', {
    staticClass: "profile2-panel"
  }, [_c('p', {
    staticClass: "profile2-panel__title"
  }, [_vm._v("Lokacija")]), _vm._v(" "), _c('div', {
    staticClass: "profile2-chip-grid"
  }, _vm._l((_vm.allCustomCategories), function(location) {
    return _c('div', {
      key: location,
      class: ['profile2-chip', _vm.selectedLocationClass(location)],
      on: {
        "click": function($event) {
          return _vm.setLocation(location)
        }
      }
    }, [_c('span', {
      staticClass: "language-item-text"
    }, [_vm._v(_vm._s(location))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "profile2-action profile2-action--logout",
    on: {
      "click": function($event) {
        return _vm.signout()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "profile2-action__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_logout')))])]), _vm._v(" "), _c('div', {
    staticClass: "profile2-action profile2-action--danger",
    on: {
      "click": function($event) {
        return _vm.deleteAccount()
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "profile2-action__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete_account')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile2-avatar"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/ic_face.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "profile2-action__icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/ic_edit.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "profile2-action__icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/ic_change_pass.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "profile2-action__icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/ic_logout.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "profile2-action__icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/ic_delete_profile.svg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8a24bde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/Profile/Profile2.vue
// module id = 844
// module chunks = 0